import { Box, Button, Popover, Typography } from '@mui/material';
import { useRef, useState } from 'react';

import { fromDaysToBiggestAsPossible } from '@/utils/dateTime';

import RetentionSelector from './retentionSelector';

interface RetentionPopoverProps {
  initialRetentionInDays: number;
  minimumRetentionInDays?: number;
  onUpdate: (retentionInDays: number) => void;
  popoverTitle?: string;
}

export const getHumanizeRetentionText = (retentionInDays: number) => {
  const formattedRetention = fromDaysToBiggestAsPossible(retentionInDays);
  const retentionText =
    formattedRetention.value === 1
      ? `a ${formattedRetention.unit.slice(0, -1)}`
      : `${formattedRetention.value} ${formattedRetention.unit}`;
  return retentionText;
};

export const RetentionPopover = (props: RetentionPopoverProps) => {
  const {
    initialRetentionInDays,
    minimumRetentionInDays = 1,
    onUpdate,
  } = props;
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const updateRetention = (updatedRetention: number) => {
    const backupRetention = Math.max(updatedRetention, minimumRetentionInDays);
    onUpdate(backupRetention);
  };

  const formattedRetention = fromDaysToBiggestAsPossible(
    initialRetentionInDays
  );

  return (
    <>
      <Button
        sx={{
          padding: '5px 12px',
        }}
        ref={anchorRef}
        onClick={() => setPopoverOpen(true)}
        data-testid='create-backup-policy-retention-select'
        disableFocusRipple
      >
        <Typography fontWeight={600}>
          {getHumanizeRetentionText(initialRetentionInDays)}
        </Typography>
        <i className='material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]' />
      </Button>
      <Popover
        disablePortal
        open={popoverOpen}
        anchorEl={anchorRef.current}
        onClose={() => setPopoverOpen(false)}
      >
        <Box className='flex flex-col p-[24px] gap-[24px] w-[300px]'>
          <Typography variant='subtitle1'>
            {props.popoverTitle || 'Choose a retention time'}
          </Typography>
          <RetentionSelector
            initialFragment={formattedRetention.unit}
            initialRetentionDays={initialRetentionInDays}
            onChange={updateRetention}
          />
        </Box>
      </Popover>
    </>
  );
};
